"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var SelectInput_1 = __importDefault(require("./SelectInput"));
var form_control_1 = __importDefault(require("@prezzee/form-control"));
var native_select_1 = require("@prezzee/native-select");
var input_label_1 = __importDefault(require("@prezzee/input-label"));
var utils_1 = require("@prezzee/utils");
var input_1 = __importDefault(require("@prezzee/input"));
var filled_input_1 = __importDefault(require("@prezzee/filled-input"));
var outlined_input_1 = __importDefault(require("@prezzee/outlined-input"));
var form_helper_text_1 = __importDefault(require("@prezzee/form-helper-text"));
var style = __importStar(require("./Select.style"));
var Select = (0, react_1.forwardRef)(function (props, ref) {
    var _a = props.autoWidth, autoWidth = _a === void 0 ? false : _a, children = props.children, className = props.className, _b = props.defaultOpen, defaultOpen = _b === void 0 ? false : _b, disabled = props.disabled, _c = props.displayEmpty, displayEmpty = _c === void 0 ? false : _c, error = props.error, fullWidth = props.fullWidth, helperText = props.helperText, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _d = props.multiple, multiple = _d === void 0 ? false : _d, _e = props.native, native = _e === void 0 ? true : _e, onClose = props.onClose, onOpen = props.onOpen, open = props.open, _f = props.options, options = _f === void 0 ? [] : _f, renderValue = props.renderValue, required = props.required, SelectDisplayProps = props.SelectDisplayProps, _g = props.variant, variant = _g === void 0 ? 'outlined' : _g, other = __rest(props, ["autoWidth", "children", "className", "defaultOpen", "disabled", "displayEmpty", "error", "fullWidth", "helperText", "id", "input", "inputProps", "label", "labelId", "multiple", "native", "onClose", "onOpen", "open", "options", "renderValue", "required", "SelectDisplayProps", "variant"]);
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputComponent = native ? native_select_1.NativeSelectInput : SelectInput_1.default;
    // TODO: fix type
    var InputComponent = {
        standard: (0, jsx_runtime_1.jsx)(input_1.default, {}),
        outlined: (0, jsx_runtime_1.jsx)(outlined_input_1.default, { label: label }),
        filled: (0, jsx_runtime_1.jsx)(filled_input_1.default, {}),
    }[variant];
    var inputComponentRef = (0, utils_1.useForkRef)(ref, InputComponent.ref);
    return ((0, jsx_runtime_1.jsxs)(form_control_1.default, __assign({ className: className, disabled: disabled, error: error, fullWidth: fullWidth, ref: ref, required: required, variant: variant, css: style.formControl }, { children: [label != null && label !== '' && ((0, jsx_runtime_1.jsx)(input_label_1.default, __assign({ id: labelId, htmlFor: id }, { children: label }))), (0, react_1.cloneElement)(InputComponent, __assign(__assign(__assign({ 
                // Most of the logic is implemented in `SelectInput`.
                // The `Select` component is a simple API wrapper to expose something better to play with.
                inputComponent: inputComponent, inputProps: __assign(__assign({ children: children, type: undefined, // We render a select. We can ignore the type provided by the `Input`.
                    multiple: multiple, options: options }, (native
                    ? { id: id }
                    : {
                        autoWidth: autoWidth,
                        defaultOpen: defaultOpen,
                        displayEmpty: displayEmpty,
                        labelId: labelId,
                        onClose: onClose,
                        onOpen: onOpen,
                        open: open,
                        renderValue: renderValue,
                        SelectDisplayProps: __assign({ id: id }, SelectDisplayProps),
                    })), inputProps) }, (multiple && native && variant === 'outlined' ? { notched: true } : {})), { inputRef: inputComponentRef, className: className, variant: variant }), other)), (helperText || typeof error === 'string') && ((0, jsx_runtime_1.jsx)(form_helper_text_1.default, __assign({ id: helperTextId }, { children: typeof error === 'string' ? error : helperText && helperText })))] })));
});
Select.displayName = 'PrezzeeSelect';
exports.default = Select;
//# sourceMappingURL=Select.js.map